<template>
  <div>
    <div style="padding-left: 30px;">
      <p style="font-size: 30px;"><b>Temp Text</b></p>
    </div>
    <div class="card" dir="rtl" style="padding: 30px;">
      <div>
        <p><b>ABSTRACT</b></p>
        <p class="white_space_pre_line" v-html="getTempText('vetting_abstract_temp_text')"></p>
      </div>
      <div style="margin-top: 20px;">
        <p><b>INTERNAL NOTES</b></p>
        <p class="white_space_pre_line" v-html="getTempText('vetting_internal_notes_temp_text')"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'temp-text',
  methods: {
    getTempText (name) {
      return this.$sanitize(localStorage.getItem(name))
    }
  }
}
</script>
